import type { Lang } from '../i18n/types';
import * as en from './registrationData.en';
import * as vi from './registrationData';

export function getRegistrationData(lang: Lang) {
  return lang === 'en' ? en : vi;
}